export default __webpack_public_path__ + "files/igpa logo-725e8fededeb6c29ead9ee584e428357.png";